import { isFreeItem } from "components/Basket/utils/freeItemCheck";
import { toItemInput } from "@shared/graphql.conversions";
import type { ItemInput, Maybe, UserType } from "@shared/graphql.types";

type PickedUserListProperties = Pick<
  UserType,
  | "basketId"
  | "basketVersion"
  | "basket"
  | "discounts"
  | "wishlist"
  | "wishlistId"
  | "wishlistVersion"
>;

// Exclude didn't work here
type ExtractUserLists = Omit<PickedUserListProperties, "discounts"> & {
  promocodes: string[];
  referralCode?: Maybe<string>;
};

const extractPromocodes = (user?: Partial<UserType>): string[] => {
  return [
    ...(user?.discounts || []),
    ...(user?.includedDiscounts || []),
    ...(user?.rejectedDiscounts || [])
  ].reduce<string[]>((acc, { code }) => {
    return code ? [...acc, code] : acc;
  }, []);
};

const extractAcceptedReferralCode = (
  user?: Partial<UserType>
): string | undefined => {
  return (
    user?.includedDiscounts?.find((discount) => discount.referralCode)
      ?.referralCode ?? undefined
  );
};

export const extract = (user: Partial<UserType>): ExtractUserLists => ({
  basketId: user?.basketId ?? "",
  basketVersion: user?.basketVersion ?? -1,
  basket:
    user?.basket?.reduce<ItemInput[]>(
      (acc, item) => (isFreeItem(item) ? acc : [...acc, toItemInput(item)]),
      []
    ) ?? [],
  promocodes: extractPromocodes(user),
  referralCode: extractAcceptedReferralCode(user),
  wishlist: user?.wishlist?.map((wish) => toItemInput(wish)) ?? [],
  wishlistId: user?.wishlistId ?? "",
  wishlistVersion: user?.wishlistVersion ?? -1
});
